import { forwardRef, memo } from 'react';
import { isEqual } from 'lodash';
export const isPropsEqual = (prev_props, next_props) => isEqual(prev_props, next_props);
export const genericMemo = memo;
export const forwardMemo = (component) => memo(forwardRef((props, ref) => {
    const new_props = { ...props, ref };
    return component(new_props);
}));
